import { createFileRoute } from '@tanstack/react-router';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import { ExportDetailsPage, useIsV2Export } from '@mews-commander/modules/src/modules/reportingExports';
import { QueryBoundary } from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';

const ExportDetailsComponent = () => {
    const { pathname, search } = Route.useMatch();
    const { id } = Route.useParams();

    const isV2Export = useIsV2Export(id);

    if (isV2Export.data) {
        return <ExportDetailsPage id={id} />;
    }

    return <BackendPage url={getBackendPageUrl({ pathname, search })} />;
};

const Component = () => (
    <QueryBoundary loader="overlay" renderErrorMessage={(error) => error?.message}>
        <ExportDetailsComponent />
    </QueryBoundary>
);

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Export/Detail/$id')({
    component: Component,
    staticData: {
        owner: MewsTeam.Analytics,
        type: RouteType.Backend,
    },
});
